import PaperTreeCreationImage from "@/assets/images/paper-tree-creation.webp";
import PaperTreeFinalImage from "@/assets/images/welcome-bg.webp";
import { cn } from "@/lib/utils";
import { ArrowLeft02Icon } from "@hugeicons-pro/core-stroke-standard";
import { HugeiconsIcon } from "@hugeicons/react";

type Props = {
  className?: string;
  compact?: boolean;
  /** The images are large (about 1 MB together), so they wait until scrolled near; a hero above the fold loads them at once. */
  loading?: "lazy" | "eager";
};

const imageFrameClassName = "min-w-0 overflow-hidden rounded-xl border border-gray-200 bg-gray-50";

export function PaperTreeProcessPreview({ className, compact = false, loading = "lazy" }: Props) {
  return (
    <div
      className={cn(
        "grid w-full grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-2 sm:gap-3",
        compact ? "max-w-md" : "max-w-2xl",
        className,
      )}
      role="img"
      aria-label="يصمم فريقنا شجرة عائلتكم يدويًا حتى تصبح لوحة نهائية جاهزة للطباعة"
    >
      <picture className={cn("block", imageFrameClassName)}>
        <source media="(prefers-reduced-motion: reduce)" srcSet={PaperTreeFinalImage} />
        <img
          src={PaperTreeCreationImage}
          alt=""
          width={540}
          height={318}
          loading={loading}
          decoding="async"
          className="aspect-video w-full object-contain"
        />
      </picture>

      <HugeiconsIcon icon={ArrowLeft02Icon} size={18} className="shrink-0 text-gray-400" aria-hidden="true" />

      <div className={imageFrameClassName} aria-hidden="true">
        <img
          src={PaperTreeFinalImage}
          alt=""
          width={1056}
          height={1790}
          loading={loading}
          decoding="async"
          className="aspect-video w-full object-contain"
        />
      </div>
    </div>
  );
}
